import * as types from './mutation-types'
export default {
  [types.SAVE_ALL_SERVICE_OCCURRENCES](state, data) {
    state.allServiceOccurrences = data
  },
}
